export const calendarDateKey = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

// Reuse the schedule's own filtering and card identity rules for each visible week.
export async function loadWeeklyCalendarCounts(month, fetchWeek) {
    const start = new Date(month.getFullYear(), month.getMonth(), 1, 10);
    start.setDate(start.getDate() - (start.getDay() + 6) % 7);
    const weeks = Array.from({ length: 6 }, (_, index) => {
        const date = new Date(start); date.setDate(date.getDate() + index * 7); return date;
    });
    const results = await Promise.all(weeks.map(fetchWeek));
    const counts = {};
    results.forEach((result, index) => {
        if (result.error) throw result.error;
        for (let day = 0; day < 7; day++) {
            const date = new Date(weeks[index]); date.setDate(date.getDate() + day);
            const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
            counts[calendarDateKey(date)] = (result.data?.[weekday] || []).length;
        }
    });
    return counts;
}
